import React from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import toast from "react-hot-toast";

const PaymentModal = ({
  open,
  onClose,
  editedPayment,
  setEditedPayment,
  handlePostPayment,
}) => {

  const formatDate = (dateString) => {
    // if (!dateString) return "N/A";
    const date = new Date(dateString);
    // if (isNaN(date.getTime())) return "Invalid Date";
    return date.toISOString().split("T")[0];
  };
  const handleSave = () => {
    const requiredFields = [
      "id",
      "plan_id",
      "payment_status",
      "total_alerts",
      "used_alerts",
      "payment_date",
      "payment_end_date",
      "amount",
      "provider_order_id",
      "payment_id",
    ];
    for (let field of requiredFields) {
      if (
        editedPayment[field] === undefined ||
        editedPayment[field] === null ||
        editedPayment[field] === ""
      ) {
        toast.error(`${field.replace("_", " ")} is required`);
        return;
      }
    }
    handlePostPayment();
  };

  if (!editedPayment) return null;
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: 800,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          maxHeight: "90vh",
          overflowY: "auto",
          p: 4,
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" mb={2}>
          Edit Payment
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TextField
              label="Payment Id"
              value={editedPayment.id || ""}
              onChange={(e) =>
                setEditedPayment({ ...editedPayment, id: e.target.value })
              }
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              label="Plan Id"
              value={editedPayment.plan_id || ""}
              onChange={(e) =>
                setEditedPayment({ ...editedPayment, plan_id: e.target.value })
              }
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth required>
              <InputLabel>Status</InputLabel>
              <Select
                label="Status"
                value={editedPayment.payment_status === true ? "true" : "false"}
                onChange={(e) => {
                  const value = e.target.value === "true";
                  const { provider_order_id, payment_id } = editedPayment;
                  if (value && (!provider_order_id || !payment_id)) {
                    toast.error(
                      "Cannot set status to Success without Razorpay Order ID and Payment ID."
                    );
                    return;
                  }
                  setEditedPayment({
                    ...editedPayment,
                    payment_status: e.target.value === "true",
                  });
                }}
                required
              >
                <MenuItem value="true">Success</MenuItem>
                <MenuItem value="false">Failed</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              label="Total Alerts"
              value={editedPayment.total_alerts ?? ""}
              onChange={(e) =>
                setEditedPayment({
                  ...editedPayment,
                  total_alerts: e.target.value,
                })
              }
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              label="Used Alerts"
              value={editedPayment.used_alerts ?? ""}
              onChange={(e) =>
                setEditedPayment({
                  ...editedPayment,
                  used_alerts: e.target.value,
                })
              }
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              type="date"
              label="Start Date"
              value={formatDate(editedPayment.payment_date)}
              onChange={(e) =>
                setEditedPayment({
                  ...editedPayment,
                  payment_date: e.target.value,
                })
              }
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              type="date"
              label="Expiry Date"
              value={
                editedPayment.payment_end_date
                  ? editedPayment.payment_end_date
                  : "null"
              }
              onChange={(e) =>
                setEditedPayment({
                  ...editedPayment,
                  payment_end_date: e.target.value,
                })
              }
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              label="Amount"
              value={editedPayment.amount || ""}
              onChange={(e) =>
                setEditedPayment({
                  ...editedPayment,
                  amount: e.target.value,
                })
              }
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              label="Razorpay Order_id"
              value={editedPayment.provider_order_id || ""}
              onChange={(e) =>
                setEditedPayment({
                  ...editedPayment,
                  provider_order_id: e.target.value,
                })
              }
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              label="payment_id"
              value={editedPayment.payment_id || ""}
              onChange={(e) =>
                setEditedPayment({
                  ...editedPayment,
                  payment_id: e.target.value,
                })
              }
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              label="invoice_id"
              value={editedPayment.invoice_id || ""}
              onChange={(e) =>
                setEditedPayment({
                  ...editedPayment,
                  invoice_id: e.target.value,
                })
              }
              fullWidth
              required
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              label="invoice_number"
              value={editedPayment.invoice_numebr || ""}
              onChange={(e) =>
                setEditedPayment({
                  ...editedPayment,
                  invoice_numebr: e.target.value,
                })
              }
              fullWidth
              required
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              label="Coupon ID"
              value={editedPayment.coupon_id ?? ""}
              onChange={(e) =>
                setEditedPayment({
                  ...editedPayment,
                  coupon_id: e.target.value,
                })
              }
              fullWidth
              required={false}
            />
          </Grid>
        </Grid>

        <Button
          variant="contained"
          onClick={handleSave}
          fullWidth
          sx={{ mt: 3 }}
        >
          Save Changes
        </Button>
      </Box>
    </Modal>
  );
};

export default PaymentModal;
